export const DRIVERS = "DRIVERS";
export const COUNT_DRIVER = "COUNT_DRIVER";
export const BUSY_DRIVER = "BUSY_DRIVER";
export const SELECTED_DRIVER = "SELECTED_DRIVER";
